import { FilterList } from '@mui/icons-material';
import { FilterButton } from '@side/pantry';
import { usePerformanceReportContext } from '../context/PerformanceReportContext';

interface Props {
  onFilterButtonClick: () => void;
  extraButton?: React.ReactNode;
  size?: 'medium' | 'small';
  id?: string;
  fullWidth?: boolean;
  fillAvailableSpace?: boolean;
}

export function FilterButtons({
  onFilterButtonClick,
  extraButton,
  size = 'medium',
  id,
  fullWidth = false,
  fillAvailableSpace = false,
}: Props) {
  const { filterCount } = usePerformanceReportContext();

  return (
    <>
      {extraButton}
      <FilterButton
        id={id}
        size={size}
        startIcon={<FilterList fontSize="small" />}
        fullWidth={fullWidth}
        filterCount={filterCount}
        onClick={onFilterButtonClick}
        sx={{
          ...(fillAvailableSpace ? { flex: '1 1 auto', minWidth: 0 } : {}),
        }}
      >
        Filters
      </FilterButton>
    </>
  );
}
